import React, {PropsWithChildren} from "react";
import styled from "styled-components";
import {OrbitComponent} from "../../components/base-components/orbit-component/orbit-component";

const SelectWrapperBox = styled.div<{width?: string;}>`
    display: inline-block;
    position: relative;
    width: ${({width}) => width};
    color: ${({theme}) => theme.colors.textLight};
`;

const SelectBox = styled.select<{width?: string; hasError?: boolean;}>`
    height: 3.7rem;
    width: ${({width}) => width};
    ${({theme}) => theme.font.presets.regular};
    font-size: 1.275rem;
    transition: border-radius 0.2s linear, border-color 0.2s linear;
    background-color: ${props => props.theme.colors.backgroundMiddleDark};
    color: inherit;
    border-radius: ${({theme}) => theme.layout.border.radius};
    border-color: ${props => props.hasError ? props.theme.colors.danger : props.theme.colors.boxBorderLighter};
    &:hover {
        border-color: ${props => props.hasError ? props.theme.colors.danger : props.theme.colors.boxBorderContrast};;
    }
    border-width: 1px;
    border-style: solid;
    padding: 0 4rem 0 1.6rem;

    /* REMOVE THE DEFAULT ARROW */
    /* for Firefox */
    -moz-appearance: none;
    /* for Safari, Chrome, Opera */
    -webkit-appearance: none;
    /* for IE10 */
    &::-ms-expand {
        display: none;
    }
`;

const SelectBoxArrow = styled.div`
    position: absolute;
    right: 0.6rem;
    top: -0.3rem;
    width: 3rem;
    padding: 0.7rem;
    margin-top: 0.72rem;
    pointer-events: none;
    border-radius: 50%;

    transition: transform 0.2s linear;
    transform: rotate(90deg);
`;

interface ISelectProps extends PropsWithChildren {
    // standard props from native html select element that will be passed directly
    id?: string;
    name?: string;
    value?: string | number;
    onChange?(event: React.ChangeEvent<HTMLSelectElement>): void;
    className?: string;

    // custom props, not native html select element
    hasError?: boolean;
    width?: string;
}

export class Select extends OrbitComponent<ISelectProps> { // React.SelectHTMLAttributes<HTMLSelectElement>
    render() {
        let {width, ...passThroughProps} = this.props;
        width = width || "auto";
        const selectWidth = width !== "auto" ? "100%" : "auto";

        const ArrowIcon = this.services.theme.currentTheme.icons.rightArrowIcon;
        return <SelectWrapperBox width={width}>
            <SelectBox
                {...passThroughProps}
                width={selectWidth}
            >
                {this.props.children}
            </SelectBox>
            <SelectBoxArrow>
                <ArrowIcon size={1.6} className="select-arrow" />
            </SelectBoxArrow>
        </SelectWrapperBox>;
    }
}